import { Col, Row } from 'antd'
import Drawer from 'components/Drawer'
import React, { useEffect, useState } from 'react'
import ViewResumeDrawer from '../../../modules/JobPreview/ViewResumeDrawer'
// import PlacementHistory from '../PlacementHistory'
export default function PlacementHistoryWithResume({
  studentId,
  isOpenHistory,
  handleClose,
  setIsOpenHistory,
  getJobRolePreview,
  getStudentPlacedList,
  getPlacementHistoryList,
  getPreview,
  selectedJobCategory,
  roleID="",
  resumeMeta,
}) {
  const [viewDrawer, setViewDrawer] = useState(false)
  const [data, setData] = useState({})
  const [placementHistoryData, setPlacementHistoryData] = useState([])
  const [placedAtObj, setPlacedAtObj] = useState(null)
  const [resumeLoading, setResumeLoading] = useState(false)
  const [placedAt, setPlacedAt] = useState([])
  const [jobCandidateState, setJobCandidateState] = useState({
    status: 'APPLIED',
    placementHistoryPageNo: 0,
    placementHistoryPageLimit: 10,
    placementStatus: 'showAll',
    placementJobCategory: 'showAll',
    placedAtPageNo: 0,
    collapsedData: [],
    collapsedIndex: null,
    placementHistoryTableLoading: false,
  })

  const content = () => {
    return (
      <Row>
        <Col xs={24}>
          <ViewResumeDrawer
            viewDrawer={viewDrawer}
            setViewDrawer={setViewDrawer}
            previewData={data}
            setIsLoading={setResumeLoading}
            isLoading={resumeLoading}
            roleID={roleID}
            resumeMeta={resumeMeta}
          />
        </Col>
      </Row>
    )
  }
  const handleCloseDrawer = () => {
    setIsOpenHistory(false)

    setJobCandidateState(prevState => ({
      ...prevState,
      collapsedIndex: null,
      placementHistoryPageNo: 0,
      placementStatus: 'showAll',
      placementJobCategory: 'showAll',
      status: 'APPLIED',
    }))
    setPlacedAt([])
    if (handleClose) {
      handleClose()
    }
    setTimeout(() => {
      setData('')
    }, 500)
  }

  const fetchPlacementHistoryList = async ({
    id = studentId,
    pageNo = jobCandidateState.placementHistoryPageNo,
    pageLimit = jobCandidateState.placementHistoryPageLimit,
    status = jobCandidateState.status,
    placementStatus = jobCandidateState?.placementStatus === 'showAll'
      ? ''
      : jobCandidateState?.placementStatus,
    placementJobCategory = jobCandidateState?.placementJobCategory === 'showAll'
      ? ''
      : jobCandidateState?.placementJobCategory,
  }) => {
    setJobCandidateState(prevState => ({
      ...prevState,
      placementHistoryTableLoading: true,
      status: status,
    }))
    try {
      const response = await getPlacementHistoryList(
        id,
        pageNo,
        pageLimit,
        status,
        placementStatus,
        placementJobCategory
      )
      if (response.status === 200) {
        setPlacementHistoryData(response?.data?.data)
      }
    } catch (err) {
      setPlacementHistoryData([])
    } finally {
      setJobCandidateState(prevState => ({
        ...prevState,
        placementHistoryTableLoading: false,
      }))
    }
  }

  const handleStatusClick = async key => {
    setJobCandidateState(prevState => ({
      ...prevState,
      status: key?.value,
      collapsedIndex: null,
      placementHistoryPageNo: 0,
      placementStatus: 'showAll',
    }))
    fetchPlacementHistoryList({
      status: key?.value,
      pageNo: 0,
      placementStatus: '',
    })
  }

  const handlePlacementHistoryChange = page => {
    let pageNo = page - 1
    setJobCandidateState(prevState => ({
      ...prevState,
      placementHistoryPageNo: pageNo,
      collapsedData: [],
      collapsedIndex: null,
    }))
    fetchPlacementHistoryList({ pageNo: pageNo })
  }

  const onFilterChange = (value, fieldName) => {
    setJobCandidateState(prevState => ({
      ...prevState,
      [fieldName]: value ?? '',
      collapsedIndex: null,
    }))

    fetchPlacementHistoryList({
      [fieldName]: value ? (value === 'showAll' ? '' : value) : '',
      pageNo: 0,
    })
  }

  const loadMorePlacedList = () => {}

  const handleCollapseClick = (data, index) => {
    if (index === jobCandidateState?.collapsedIndex) {
      setJobCandidateState(prevState => ({
        ...prevState,
        collapsedData: [],
        collapsedIndex: null,
      }))
    } else {
      const round = data?.interview_workflow?.rounds ?? []
      setJobCandidateState(prevState => ({
        ...prevState,
        collapsedData: round,
        collapsedIndex: index,
      }))
    }
  }

  const fetchStudentPlacedList = async ({
    id = studentId,
    pageNo = jobCandidateState?.placedAtPageNo,
  }) => {
    try {
      const response = await getStudentPlacedList(id, pageNo, 500)
      setPlacedAtObj({
        filteredResult: response?.data?.data?.filteredResult || [],
        count: response?.data?.data?.count,
        page: response?.data?.data?.page,
        limit: response?.data?.data?.limit,
        totalPage: response?.data?.data?.totalPage,
      })
      setPlacedAt(response?.data?.data?.filteredResult)
    } catch (err) {
      //
    }
  }

  const fetchDetails = async selectedJobCategory => {
    const placementJobCategory = selectedJobCategory
      ? selectedJobCategory
      : 'showAll'

    setJobCandidateState(prevState => ({
      ...prevState,
      placementJobCategory,
    }))
    await fetchPreviewData(studentId)

    await fetchPlacementHistoryList({
      id: studentId,
      status: 'APPLIED',
      pageNo: 0,
      placementJobCategory:
        placementJobCategory === 'showAll' ? '' : placementJobCategory,
    })
    await fetchStudentPlacedList({
      id: studentId,
      pageNo: jobCandidateState?.placedAtPageNo,
    })
  }

  useEffect(() => {
    if (studentId && isOpenHistory) {
      fetchDetails(selectedJobCategory)
    }
  }, [isOpenHistory, selectedJobCategory])

  const fetchPreviewData = async id => {
    try {
      setResumeLoading(true)
      const response = await getPreview(id, roleID)
      setResumeLoading(false)
      setData(response)
    } catch (error) {
      console.error('Error fetching preview data:', error)
    } finally {
      setResumeLoading(false)
    }
  }
  return (
    <Drawer
      width="80%"
      title={' Details of candidate'}
      placement="right"
      closable={true}
      visible={isOpenHistory}
      content={content()}
      overflowBody={'hidden'}
      onClose={() => handleCloseDrawer()}
    />
  )
}
